import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'hasValue',
    standalone: true
})
export class HasValuePipe implements PipeTransform {

    transform(value: any | any[]): boolean {
        if (!value) {
            return false;
        }

        if (Array.isArray(value) || (value && typeof value === 'object' && 'length' in value)) {
            return Array.from(value).some(x => x || x === 0);
        }        

        return true;
    }
}